export default "__VITE_ASSET__CxCW1xm4__"